export default __webpack_public_path__ + "static/media/bronwyn_king.92461d54.jpg";